'use strict';
// import './style.css';

export class FormFeedback
{
    constructor(options = [])
    {
        this.options = options;
        this.init();
    }

    init()
    {
        const instance = this

        document.getElementById('js-form-feedback').addEventListener("submit", function (e) {
            instance.sendForm(e)
        })
    }

    sendForm(e) {
        e.preventDefault()
        let form = e.target;
        let url = form.getAttribute('action')
        let formData = new FormData(form)

        fetch(url, {
            method: 'POST',
            body: formData
        }).then(function (response) {
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' + response.status);
                return;
            }
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                response.json().then(function(data) {               
                    const formErrors = JSON.parse(JSON.stringify(data.errors));                            
                    for (let i in formErrors) {
                        let key = i;
                        let errorVal = formErrors[i];

                        let errorDiv = document.createElement('div');
                        errorDiv.className = "alert";
                        errorDiv.innerHTML = errorVal;
                        document.body.append(errorDiv);
                        document.querySelector('.js-form-errors').append(errorDiv)
                    }
                })
            } else {
                form.reset()
                $.fancybox.close();
                setTimeout(function(){$.fancybox.open({src:'/local/ajax/popups/send_success.php',type:'ajax',touch:false})},100)
            }
        }).catch(function (err) {
            console.log('Fetch Error :-S', err);
        });
    }
}